export default __webpack_public_path__ + "static/media/pmv-rating.bfff6bc6.svg";